// EventBus.js
import Vue from 'vue';
export const EventBus = new Vue();
export const SIDEBAR_REVEAL_EVENT = "sidebar-reveal";
